import { PullRequestSummaryDto } from '../../types/pipelineFlow';

interface PullRequestsSectionProps {
  pullRequests: PullRequestSummaryDto[];
}

export function PullRequestsSection({ pullRequests }: PullRequestsSectionProps) {
  if (!pullRequests || pullRequests.length === 0) {
    return (
      <div>
        <h5 className="text-sm font-semibold text-gray-900 mb-3">Related Pull Requests</h5>
        <p className="text-sm text-gray-500">No pull requests found for this build.</p>
      </div>
    );
  }

  return (
    <div>
      <h5 className="text-sm font-semibold text-gray-900 mb-3">Related Pull Requests ({pullRequests.length})</h5>
      <div className="space-y-3">
        {pullRequests.map((pr) => (
          <div key={pr.id} className="flex items-start justify-between p-3 bg-gray-50 rounded-lg">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-medium text-gray-900">#{pr.id}</span>
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                  pr.status.toLowerCase() === 'completed' ? 'bg-green-100 text-green-800' :
                  pr.status.toLowerCase() === 'active' ? 'bg-blue-100 text-blue-800' :
                  pr.status.toLowerCase() === 'abandoned' ? 'bg-gray-100 text-gray-800' :
                  'bg-yellow-100 text-yellow-800'
                }`}>
                  {pr.status}
                </span>
              </div>
              <h6 className="text-sm font-medium text-gray-900 truncate">{pr.title}</h6>
              <div className="text-xs text-gray-500 mt-1 space-y-1">
                <div>
                  <span className="font-mono">{pr.sourceBranch}</span> → <span className="font-mono">{pr.targetBranch}</span>
                </div>
                <div>Created by {pr.createdBy} on {new Date(pr.createdDate).toLocaleDateString()}</div>
              </div>
            </div>
            <a
              href={pr.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-2.5 py-1 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors"
            >
              <svg className="mr-1 h-3 w-3" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
              View Pull Request
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}